<template>
    <div class="vks-banner">
        <div class="vks-banner__header">
            <img src="/wp-content/themes/rigips/images/v3/banners/vks.png">
            <div class="textcontent">
                <h3 class="vks-banner__title">Chcete mít Velkou knihu sádrokartonu vždy po ruce?</h3>
                <h4 class="vks-banner__subtitle">Objednejte si ji v tištěné verzi až na vaši adresu!</h4>
            </div>
        </div>

        <div class="textcontent">
            <p class="vks-banner__price">Cena včetně dopravy: <strong>770 Kč</strong> vč. DPH</p>
        </div>
        <a class="button view-primary-light" href="https://www.rigips.cz/skola-suche-vystavby/objednavka/nvpf91iaags37l9e0vt6zk1rc0cbv2">Objednat</a>
    </div>
</template>

<script>
    export default {
        name: "VksBanner"
    }
</script>



// WEBPACK FOOTER //
// src/components/download/VksBanner.vue